import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    resend: {
        id: 'resend_code_component.resend',
        defaultMessage: 'Resend code',
    },
    sending: {
        id: 'resend_code_component.sending',
        defaultMessage: 'Sending code...',
    },
    resendInCode: {
        id: 'resend_code_component.resend_in',
        defaultMessage: 'Resend in {seconds} sec',
    },
})
